import { render, staticRenderFns } from "./AddPurchase.vue?vue&type=template&id=634413b2&"
import script from "./AddPurchase.vue?vue&type=script&lang=js&"
export * from "./AddPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634413b2')) {
      api.createRecord('634413b2', component.options)
    } else {
      api.reload('634413b2', component.options)
    }
    module.hot.accept("./AddPurchase.vue?vue&type=template&id=634413b2&", function () {
      api.rerender('634413b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddPurchase.vue"
export default component.exports